module.exports = __webpack_public_path__ + "themes/soloppgang/fonts/Calluna-Light.otf";